import React, { PropsWithChildren } from 'react';
import { SizeTokens, View, ViewProps } from 'tamagui';
import { Row } from './flex';

type DividerWithTextProps = PropsWithChildren &
  ViewProps & {
    size?: SizeTokens;
    lineProps?: ViewProps;
  };

export const DividerWithText: React.FC<DividerWithTextProps> = ({
  children,
  size = '$0.25',
  lineProps,
  ...props
}) => {
  return (
    <Row alignItems={'center'} gap={'$3'} my={'$4'} {...props}>
      <View flex={1} backgroundColor={'$borderColor'} height={size} {...lineProps} />
      {children}
      <View flex={1} backgroundColor={'$borderColor'} height={size} {...lineProps} />
    </Row>
  );
};
